// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AdapterProtocol } from "../archive/adapter-protocol";
import { AdapterType } from "../archive/adapter-type";
import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /adapters/summary — adapter summary for list views.
 */
export class AdapterSummary implements flatbuffers.IUnpackableObject<AdapterSummaryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AdapterSummary {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAdapterSummary(bb: flatbuffers.ByteBuffer, obj?: AdapterSummary): AdapterSummary {
    return (obj || new AdapterSummary()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsAdapterSummary(
    bb: flatbuffers.ByteBuffer,
    obj?: AdapterSummary,
  ): AdapterSummary {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AdapterSummary()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  version(): string | null;
  version(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  version(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  protocolType(): AdapterProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterProtocol.MCE;
  }

  liftType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  type(): AdapterType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterType.REST;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  serverId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startAdapterSummary(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addVersion(builder: flatbuffers.Builder, versionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, versionOffset, 0);
  }

  static addProtocolType(builder: flatbuffers.Builder, protocolType: AdapterProtocol) {
    builder.addFieldInt8(3, protocolType, AdapterProtocol.MCE);
  }

  static addLiftType(builder: flatbuffers.Builder, liftType: LiftType) {
    builder.addFieldInt8(4, liftType, LiftType.ELEVATOR);
  }

  static addType(builder: flatbuffers.Builder, type: AdapterType) {
    builder.addFieldInt8(5, type, AdapterType.REST);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(6, +active, +false);
  }

  static addServerId(builder: flatbuffers.Builder, serverIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, serverIdOffset, 0);
  }

  static endAdapterSummary(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): AdapterSummaryT {
    return new AdapterSummaryT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.version(),
      this.protocolType(),
      this.liftType(),
      this.type(),
      this.active(),
      this.serverId() !== null ? this.serverId()!.unpack() : null,
    );
  }

  unpackTo(_o: AdapterSummaryT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.version = this.version();
    _o.protocolType = this.protocolType();
    _o.liftType = this.liftType();
    _o.type = this.type();
    _o.active = this.active();
    _o.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
  }

  unpackFields(...fields: string[]): AdapterSummaryT {
    const t = new AdapterSummaryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("version")) {
      t.version = this.version();
    }
    if (fieldSet.has("protocol_type")) {
      t.protocolType = this.protocolType();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("server_id")) {
      t.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    }
    return t;
  }
}

export class AdapterSummaryT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public version: string | Uint8Array | null = null,
    public protocolType: AdapterProtocol = AdapterProtocol.MCE,
    public liftType: LiftType = LiftType.ELEVATOR,
    public type: AdapterType = AdapterType.REST,
    public active: boolean = false,
    public serverId: UuidT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const version = this.version !== null ? builder.createString(this.version!) : 0;
    const serverId = this.serverId !== null ? this.serverId!.pack(builder) : 0;

    AdapterSummary.startAdapterSummary(builder);
    AdapterSummary.addId(builder, id);
    AdapterSummary.addName(builder, name);
    AdapterSummary.addVersion(builder, version);
    AdapterSummary.addProtocolType(builder, this.protocolType);
    AdapterSummary.addLiftType(builder, this.liftType);
    AdapterSummary.addType(builder, this.type);
    AdapterSummary.addActive(builder, this.active);
    AdapterSummary.addServerId(builder, serverId);

    return AdapterSummary.endAdapterSummary(builder);
  }

  clone(): AdapterSummaryT {
    const obj = new AdapterSummaryT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.version = this.version;
    obj.protocolType = this.protocolType;
    obj.liftType = this.liftType;
    obj.type = this.type;
    obj.active = this.active;
    obj.serverId = this.serverId !== null ? this.serverId!.clone() : null;
    return obj;
  }

  equals(other: AdapterSummaryT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.version !== other.version) return false;
    if (this.protocolType !== other.protocolType) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.type !== other.type) return false;
    if (this.active !== other.active) return false;
    if (this.serverId !== null && other.serverId !== null) {
      if (!this.serverId!.equals(other.serverId!)) return false;
    } else if (this.serverId !== other.serverId) return false;
    return true;
  }
}

export function verifyAdapterSummary(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
